import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import BillForm from "./BillForm";
import Pagination from "../../../utils/pagination/Pagination";
import "./Bill.css";
import { Trash2, SquarePen, Eye, Plus } from "lucide-react";
import { getBilling } from "../../../redux/reduxApi/billingReduxApi";
import { countBilling } from "../../../redux/api/billingApi/billingApi";
import { deleteBilling } from "../../../redux/api/billingApi/billingApi";
import { deletebillingAction } from "../../../redux/reduxSlice/BillingSlice";
import { useNavigate } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Checkbox, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, Button, Spinner, ModalCloseButton } from "@chakra-ui/react";
import EllipsisMenu from "../../../utils/EllipsisDropdown/EllipsisMenu";
import { formatDate } from "../../../utils/commonFunction/CommonFunction";

function Bill(sidebarColor) {
  const desktopRef = useRef(null);
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const billingData = useSelector((state) => state?.billing?.billing);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [deleteBillingROWID, setDeleteBillingROWID] = useState("");
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [dataToEdit, setDataToEdit] = useState({});
  const [billingROWId, setBillingROWId] = useState("");
  const [billingId, setBillingId] = useState("");
  //to show add & delete button according to permissions
  const permissions = localStorage.getItem("permissions");
  const filterData = JSON.parse(permissions);

  useEffect(() => {
    setLoading(true);
    dispatch(getBilling({ page: currentPage, limit: 30, size: 30 }))
      .catch((error) => {
        console.error("Error fetching Billing data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, dispatch]);

  const fetchTotalCount = async () => {
    try {
      const response = await countBilling();
      console.log("API Response:", response.data);
      const count = parseInt(response.data.count, 10);
      setTotalCount(count);
    } catch (error) {
      console.error("Error fetching total Billing count:", error);
    }
  };

  const handleNewData = () => {
    fetchTotalCount();
  };

  useEffect(() => {
    fetchTotalCount();
  }, []);

  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    const idsToDelete = selectedRows.length === 0 ? [deleteBillingROWID] : selectedRows;
    Promise.all(idsToDelete.map((id) => deleteBilling(id)))
      .then(() => {
        setSelectedRows([]);
        dispatch(deletebillingAction(idsToDelete));
        toast.success("Row deleted successfully");
        fetchTotalCount();
      })
      .catch(() => {
        toast.error("Row not deleted");
      })
      .finally(() => {
        setIsOpen(false);
        setDeleteBillingROWID("");
        setShowProgressBar(false);
        setLoading(false);
      });
  };

  // Modal for delete confirmation
  const openTrash = (ROWID) => {
    setDeleteBillingROWID(ROWID);
    setIsOpen(true);
  };
  const closeTrash = () => {
    setIsOpen(false);
    setDeleteBillingROWID("");
  };

  // Handle row selection
  const handleRowSelect = (ROWID) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows.includes(ROWID);
      const updatedRows = isSelected ? prevSelectedRows.filter((id) => id !== ROWID) : [...prevSelectedRows, ROWID];
      setSelectedRows(prevSelectedRows);
      setBillingROWId(prevSelectedRows.join(","));
      console.log("Selected rows:", updatedRows);
      return updatedRows;
    });
  };

  // Handle "select all" functionality
  const handleSelectAllRows = () => {
    setSelectedRows((prevSelectedRows) => {
      const updatedRows = prevSelectedRows.length === billingData?.length ? [] : billingData.map((item) => item?.billing?.ROWID);

      console.log("Selected rows:", updatedRows);
      return updatedRows;
    });
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };
  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const heading = [
    {
      th: <Checkbox key="checkbox" isChecked={selectedRows.length === billingData?.length} onChange={handleSelectAllRows} />,
    },
    { th: "Actions" },
    { th: "Vendor Name" },
    { th: "Bill#" },
    { th: "Order Number" },
    { th: "CCS Bill Serial No" },
    { th: "Bill Date" },
    { th: "Due date" },
    { th: "Payment Terms" },
  ];

  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      {showProgressBar && <ProgressBar colorScheme="pink" />}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <ModalFooter>
            <Button className="create-button" mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={closeTrash}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <div>
        <div ref={desktopRef}>
          <div className="d-flex justify-content-end">
            {selectedRows.length === 0 && (
              <>
                {filterData?.find((mod) => mod.moduleName === "Bill" && mod.add === true) && (
                  <button className="new-button mx-2" onClick={openDrawer}>
                    <Plus size="18px" />
                    <span className="ms-1">New</span>
                  </button>
                )}
              </>
            )}
          </div>
          {selectedRows.length > 0 && (
            <>
              {filterData?.find((mod) => mod.moduleName === "Bill" && mod.delete === true) && (
                <button className="new-button mx-2" onClick={openTrash}>
                  <Plus size="18px" />
                  <span className="ms-1">Delete All</span>
                </button>
              )}
            </>
          )}
        </div>
        <div className="custom-scroll " style={{ minHeight: "75vh" }}>
          <TableContainer className="card card-detail mt-1" style={{ height: "75vh" }}>
            <Table variant="simple" size="sm">
              <Thead>
                <Tr className="tr-border">
                  {heading.map((item, index) => (
                    <Th className="py-1 th-color" key={index}>
                      {item.th}
                    </Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {billingData &&
                  billingData?.map((item, index) => (
                    <Tr key={index} className="tr-border" style={{ position: "relative" }}>
                      <Td>
                        <Checkbox isChecked={selectedRows.includes(item?.billing?.ROWID)} onChange={() => handleRowSelect(item?.billing?.ROWID)} />
                      </Td>
                      {/* <Td>
                      <Tr className="d-flex gap-1">
                        <Link to="/bill-detail-view" state={{ ROWID: item?.ROWID }}>
                          <i style={{ cursor: 'pointer' }}>
                            <Eye color="#ff176b" size="16px" strokeWidth="1" />
                          </i>
                        </Link>
                        {filterData[15].moduleName === "Bill" && filterData[15].modifyAll === true ?
                          <i onClick={() => { openDrawer(item.billing); setDataToEdit(item.billing); setIsUpdateMode(true); setBillingId(item?.billing?.ROWID) }} style={{ cursor: 'pointer' }}>
                            <SquarePen color="#ff176b" size="16px" strokeWidth="1" />
                          </i> : ""}

                        {filterData[15].moduleName === "Bill" && filterData[15].delete === true ?
                          <i onClick={(e) => { openTrash(e); setDeleteBillingROWID(item?.billing?.ROWID); }} style={{ cursor: 'pointer' }}>
                            <Trash2 color="#ff176b" size="16px" strokeWidth="1" onClick={openTrash} />
                          </i> : ""}
                      </Tr>
                    </Td> */}
                      <Td style={{ width: "110px", textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                        <EllipsisMenu
                          item={item}
                          onView={() => navigate("/bill-detail-view", { state: { ROWID: item?.ROWID } })}
                          onEdit={() => {
                            openDrawer(item.billing);
                            setDataToEdit(item.billing);
                            setIsUpdateMode(true);
                            setBillingId(item?.billing?.ROWID);
                          }}
                          onDelete={() => {
                            openTrash();
                            setDeleteBillingROWID(item?.billing?.ROWID);
                          }}
                          permissions={{
                            canEdit: filterData?.find((mod) => mod.moduleName === "Bill" && mod.modifyAll === true),
                            canDelete: filterData?.find((mod) => mod.moduleName === "Bill" && mod.delete === true),
                            canView: true, // Usually always true, but you can make this dynamic too
                          }}
                        />
                      </Td>

                      <Td className="font-colors">{item?.billing?.vendorName}</Td>
                      <Td className="font-colors">{item?.billing?.bill}</Td>
                      <Td className="font-colors">{item?.billing?.orderNumber}</Td>
                      <Td className="font-colors">{item?.billing?.ccsBillserialNo}</Td>
                      <Td className="font-colors">{formatDate(item?.billing?.billDate)}</Td>
                      <Td className="font-colors">{formatDate(item?.billing?.dueDate)}</Td>
                      <Td className="font-colors">{item?.billing?.paymentTerms}</Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
        <div className="footer">
          <div className="footer d-flex fixed-bottom start-20">
            <div className="total" style={{ marginLeft: "16%", marginTop: "15px" }}>
              <p class="fw-semibold">Total Count: {totalCount}</p>
            </div>

            <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
              <Pagination totalPages={Math.ceil(totalCount / 30)} onPageChange={setCurrentPage} />
            </div>
          </div>
        </div>
        <BillForm
          closeDrawer={closeDrawer}
          isDrawerOpen={isDrawerOpen}
          isUpdateMode={isUpdateMode}
          billingId={billingId}
          onNewDataAdded={handleNewData}
          billingROWId={billingROWId}
          dataToEdit={dataToEdit}
          setIsUpdateMode={setIsUpdateMode}
        />
      </div>
    </>
  );
}

export default Bill;
